





























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import Echarts from '@/components/Echarts/Echarts.vue'
import { UserModule } from '../../store/modules/user'
import { DateUnitTypeMap, EDateUnitType, DevTypeMap, StatsRuntimeUnitTabsMap, EStatsRunTimeUnit, StatsLocalUnitMap, EStatsLocalUnit, EDevType } from '../../model/const'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectDepartment from '@/components/Select/SelectDepartment.vue'
import api from '../../api'
import { formatDate, accMul } from '../../utils/utils'

@Component({
  components: {
    PublicQuery,
    Echarts,
    SelectRegion,
    SelectDepartment,
  },
})
export default class StatsRunTime extends Vue {
  private echartsOption: any = {}
  private isCompareStatus: boolean = false
  private isNotData: boolean = false
  private statsRunTimeUnit: EStatsRunTimeUnit = EStatsRunTimeUnit.ADDTIME
  private statsRunTimeTabs: any[] = Array.from(StatsRuntimeUnitTabsMap).map(([name, label]) => ({ label, name }))
  private typeOption: any[] = Array.from(StatsLocalUnitMap).map(([value, label]) => ({ label, value }))
  private devTypeOption: any[] = Array.from(DevTypeMap).map(([value, label]) => ({ label, value }))

  private lineColors: any[] = ['#d4ac60', '#3b65ff', '#ff742a']
  private lineComparseColors: any[] = ['#ffa500', '#2CBE60', '#cd5c5c']
  private queryItems: IFormItem[] = [
    {
      label: '统计时长',
      key: 'unit',
      type: 'select',
      options: [...DateUnitTypeMap].map(([value, label]) => ({
        label,
        value,
      })),
    },
    {
      label: '空间类型',
      key: 'spaceTypeId',
      type: 'select',
      options: [{ label: '全部', value: '' }, ...UserModule.spaceTypeList.map((item) => ({
        label: item.spaceName,
        value: item.id,
      }))],
    },
    {
      label: '选择日期',
      key: 'date',
      type: 'date',
      dateType: 'daterange',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  private queryParams = {
    date: [],
    unit: 'DAY',
    region: [],
    type: 1,
    spaceTypeId: '',
    cdate: [],
    devType: EDevType.AIR,
  }
  @Watch('queryParams.unit')
  private watchUnit(now: EDateUnitType) {
    let dateType = ''
    switch (now) {
      case EDateUnitType.DAY:
        dateType = 'daterange'
        break
      case EDateUnitType.MONTH:
        dateType = 'monthrange'
        break
      case EDateUnitType.YEAR:
        dateType = 'monthrange'
        break
      default:
        dateType = 'daterange'
        break
    }
    if (this.queryItems.findIndex(_ => _.key === 'date') !== -1) {
      this.queryItems.splice(this.queryItems.findIndex(_ => _.key === 'date'), 1, {
        label: '选择日期',
        key: 'date',
        type: 'date',
        dateType: dateType as any,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
        },
      })
    }
    if (this.queryItems.findIndex(_ => _.key === 'cdate') !== -1) {
      this.queryItems.splice(this.queryItems.findIndex(_ => _.key === 'cdate'), 1, {
        label: '对比日期',
        key: 'cdate',
        type: 'date',
        dateType: dateType as any,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          },
        },
      })
    }
  }

  private handleTabClick() {
    // this.queryParams = {
    //   date: [],
    //   unit: 'DAY',
    //   region: [],
    //   spaceTypeId: '',
    //   cdate: [],
    // }
    // this.isCompareStatus = false
    // this.isNotData = true
    this.queryChange()
  }

  private onCompareBtn() {
    this.isCompareStatus = !this.isCompareStatus
  }
  @Watch('isCompareStatus')
  private watchIsCompareStatus(now: boolean) {
    const cdateIndex = this.queryItems.findIndex(item => item.key === 'cdate')
    const devTypeIndex = this.queryItems.findIndex(item => item.key === 'devType')
    if (now) {
      if (cdateIndex === -1) {
        this.queryItems.push({
          label: '对比日期',
          key: 'cdate',
          type: 'date',
          dateType: 'daterange',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          },
        })
      }
      if (devTypeIndex === -1) {
        this.queryItems.push({
          label: '对比设备',
          key: 'devType',
          type: 'select',
          options: this.devTypeOption,
        })
        this.queryParams.devType = this.devTypeOption[0] ? this.devTypeOption[0].value : ''
      }
      this.watchUnit(this.queryParams.unit as any)
    } else {
      if (devTypeIndex !== -1) this.queryItems.splice(devTypeIndex, 1)
      if (cdateIndex !== -1) this.queryItems.splice(cdateIndex, 1)
      this.queryChange()
    }
  }
  private queryChange() {
    const { region = [], unit = '', date = [], cdate = [], type = 1, spaceTypeId = '' } = this.queryParams || {}
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    if (!region || !region.length) {
      if (type === EStatsLocalUnit.POSITION) {
        this.$message.warning('请选择统计位置')
      }
      if (type === EStatsLocalUnit.DEPARTMENT) {
        this.$message.warning('请选择统计部门')
      }
      return
    }
    if (this.isCompareStatus && (!cdate || !cdate.length)) {
      this.$message.warning('请选择对比日期')
      return
    }
    console.log('orgId' + UserModule.orgInfo.orgId)
    console.log('unit' + unit)
    console.log('spaceTypeId' + spaceTypeId)
    console.log('type' + type)
    console.log('region' + region)
    let statsrequst = api.getRunTimeStats({
      orgId: UserModule.orgInfo.orgId,
      posIds: type === EStatsLocalUnit.POSITION ? region.map((item: any) => item[item.length - 1]) : region,
      unit,
      start: date[0],
      end: date[1],
      spaceTypeId,
      type,
    })
    if (this.isCompareStatus) {
      Promise.all([statsrequst, api.getRunTimeStats({
        orgId: UserModule.orgInfo.orgId,
        posIds: type === EStatsLocalUnit.POSITION ? region.map((item: any) => item[item.length - 1]) : region,
        unit,
        start: cdate[0],
        end: cdate[1],
        spaceTypeId,
        type,
      })]).then(([data, compareData]) => {
        data = Object.entries(data).map(([key, value]: any[]) => {
          return {
            devName: DevTypeMap.get(key),
            value: value,
          }
        })
        compareData = Object.entries(compareData).map(([key, value]: any[]) => {
          return {
            devName: DevTypeMap.get(key),
            value: value,
          }
        })
        this.getEcahrtsSumRunTimeCompare(data, compareData)
        this.isNotData = false
      })
    } else {
      statsrequst.then((data) => {
        this.getEchartsSumRunTime(data)
        this.isNotData = false
      })
    }
  }
  private costumDateFormatter(value: any) {
    let result = ''
    switch (this.queryParams.unit) {
      case EDateUnitType.DAY:
        result = formatDate(value, 'MM月DD日')
        break
      case EDateUnitType.MONTH:
        result = formatDate(value, 'YYYY年MM月')
        break
      case EDateUnitType.YEAR:
        result = formatDate(value, 'YYYY年')
        break
      default:
        result = ''
        break
    }
    return result
  }
  private axisLabelDateFormatter(value: any) {
    let result = ''
    switch (this.queryParams.unit) {
      case EDateUnitType.DAY:
        result = formatDate(value, 'MM-DD')
        break
      case EDateUnitType.MONTH:
        result = formatDate(value, 'YY-MM')
        break
      case EDateUnitType.YEAR:
        result = formatDate(value, 'YYYY')
        break
      default:
        result = ''
        break
    }
    return result
  }
  private axisLabelUnitFormatter(value: number) {
    return value > 1000 ? `${value / 1000}k` : value
  }
  /** 汇总图 */
  private getEchartsSumRunTime(data: any) {
    data = Object.entries(data).map(([key, value]: any[]) => {
      return {
        devName: DevTypeMap.get(key),
        value: value,
      }
    })
      //console.log(data);
  // let a=[]
  //     for(let i=0;i<29;i++){
      
  //       a.push(data[1].value[i].avgTime)
  //     }
  //     let b=[]
  //     for(let i=0;i<29;i++){
      
  //       b.push(data[2].value[i].countDate)
  //     }
  //     console.log(b);
      
  //       console.log(data[1].value);
  //         console.log(data[2].value);
    this.echartsOption = {
      title: {
        text: `设备运行${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)}变化趋势`,
      },
      color: this.lineColors,
      graphic: [
        {
          type: 'text',
          z: 100,
          left: 'center',
          bottom: 0,
          cursor: 'default',
          style: {
            fill: '#666666',
            text: `${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)} ${this.axisLabelDateFormatter(this.queryParams.date[0])}至${this.axisLabelDateFormatter(this.queryParams.date[1])}`,
            font: '14px Microsoft YaHei',
          },
        },
      ],
      toolbox: {
        right: '3%',
        top: 40,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {
            name: '运行时长分析',
          },
        },
      },
      legend: {
        // data: data.map((item: any) => item.devName).reverse(),
        itemHeight: 10, // 改变圆圈大小
        icon: 'circle',
        right: '3%',
        // textStyle: {
        //   fontSize: 14,
        // },
      },
      grid: {
        left: '3%',
        right: '3%',
        top: 90,
        bottom: '5%',
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any[]) => {
          let result = ''
          result += params.reduce((prev, curr, index) => {
            if (index === 0) {
              prev += `${formatDate(curr.axisValue)}<br>`
            }
            const rsc = prev += `${curr.marker}${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)}-${DevTypeMap.get(curr.value[2].devType)}&nbsp&nbsp${curr.value[2][this.statsRunTimeUnit]}<br/>`
            return rsc
          }, result)
          return result
        },
      },
      xAxis: {
        type: 'category',
        minInterval: 1,
        axisLabel: {
          formatter: this.axisLabelDateFormatter,
          rotate: 60,
        },
        axisTick: {
          show: false,
          alignWithLabel: true,
        },
        axisLine: {
          show: false,
        },
      },
      yAxis: {
        name: '时长(h)',
        type: 'value',
        nameLocation: 'end',
        nameTextStyle: {
          align: 'right',
          padding: [0, 0, 9, 0],
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          formatter: this.axisLabelUnitFormatter,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      series: data.map((goods: any) => {
        return {
          name: goods.devName,
          data: goods.value.map((item: any) => ([
            item.countDate,
            item[this.statsRunTimeUnit],
            item,
          ])),
          showSymbol: false,
          // symbolSize: 8,
          // itemStyle: {
          //   normal: {
          //     shadowBlur: 2,
          //     shadowColor: 'rgba(0, 0, 0, .12)',
          //     shadowOffsetX: 2,
          //     shadowOffsetY: 2,
          //   },
          // },
          // lineStyle: {
          //   normal: {
          //     width: 3,
          //     shadowColor: 'rgba(0,0,0,0.4)',
          //     shadowBlur: 10,
          //     shadowOffsetX: 4,
          //     shadowOffsetY: 10,
          //   },
          // },
          tooltip: {
            trigger: 'axis',
          },
          type: 'line',
          smooth: true,
        }
      }).reverse(),
    }
  }
  /** 对比图 */
  private getEcahrtsSumRunTimeCompare(data: any[], cdata: any[]) {
    // console.log('data' + JSON.stringify(data))
    // console.log('cdata' + JSON.stringify(cdata))
    this.echartsOption = {
      title: {
        text: `设备运行${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)}变化趋势(对比)`,
      },
      // color: this.lineColors,
      toolbox: {
        right: '3%',
        top: 40,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {
            name: '运行时长(对比)',
          },
        },
      },
      legend: {
        // data: devs.map((item) => item.devName).reverse(),
        itemHeight: 14, // 改变圆圈大小
        icon: 'circle',
        left: 'center',
        bottom: 0,
        itemGap: 80,
        textStyle: {
          fontSize: 14,
        },
      },
      grid: {
        left: '3%',
        right: '3%',
        top: 90,
        bottom: '5%',
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any[]) => {
          let result = ''
          result += params.reduce((prev, curr, index) => {
            const item = curr.data.item
            prev += `${curr.data.item.timeTitle}: ${formatDate(curr.data.item.countDate, 'YYYY-MM-DD')}<br>`
            const rsc = prev += `${curr.marker}${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)}-${DevTypeMap.get(curr.data.item.devType)}&nbsp&nbsp${curr.data.item[this.statsRunTimeUnit]}<br/>`
            return rsc
          }, result)
          return result
        },
      },
      xAxis: {
        type: 'category',
        data: data[0] && Array.isArray(data[0].value) ? data[0].value.map((item: any) => item.countDate) : [],
        axisLabel: {
          interval: 0,
          formatter: this.axisLabelDateFormatter,
          rotate: 60,
        },
        axisTick: {
          show: false,
          alignWithLabel: true,
        },
        axisLine: {
          show: false,
        },
      },
      yAxis: {
        name: '时长(h)',
        type: 'value',
        nameLocation: 'end',
        nameTextStyle: {
          align: 'right',
          padding: [0, 0, 9, 0],
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          formatter: this.axisLabelUnitFormatter,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      series: [
        ...data.filter(item => item.devName === DevTypeMap.get(this.queryParams.devType)).map((goods: any, index: number) => {
          return {
            name: `${this.axisLabelDateFormatter(this.queryParams.date[0])}至${this.axisLabelDateFormatter(this.queryParams.date[1])}${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)} -${goods.devName}`,
            tooltip: {
              trigger: 'axis',
            },
            type: 'line',
            smooth: true,
            // symbol: 'circle',
            // symbolSize: 8,
            showSymbol: false,
            itemStyle: {
              normal: {
                color: this.getLineColor(goods.devName).color,
              },
            },
            data: goods.value.map((item: any) => ({
              value: item[this.statsRunTimeUnit],
              item: {
                ...item,
                timeTitle: '查询时间',
              },
            })),
          }
        }).reverse(),
        ...cdata.filter(item => item.devName === DevTypeMap.get(this.queryParams.devType)).map((goods: any, index: number) => {
          return {
            name: `${this.axisLabelDateFormatter(this.queryParams.cdate[0])}至${this.axisLabelDateFormatter(this.queryParams.cdate[1])}${StatsRuntimeUnitTabsMap.get(this.statsRunTimeUnit)}-${goods.devName}`,
            tooltip: {
              trigger: 'axis',
            },
            type: 'line',
            smooth: true,
            // symbol: 'circle',
            // symbolSize: 8,
            showSymbol: false,
            itemStyle: {
              normal: {
                color: this.getLineColor(goods.devName).ccolor,
              },
            },
            data: goods.value.map((item: any) => ({
              value: item[this.statsRunTimeUnit],
              item: {
                ...item,
                timeTitle: '对比时间',
              },
            })),
          }
        }).reverse(),
      ],
    }
  }
  private getLineColor(name: string) {
    let result = {
      color: '',
      ccolor: '',
    }
    switch (name) {
      case '空调':
        result.color = this.lineColors[1]
        result.ccolor = this.lineComparseColors[1]
        break
      case '灯光':
        result.color = this.lineColors[2]
        result.ccolor = this.lineComparseColors[2]
        break
      case '其他':
        result.color = this.lineColors[0]
        result.ccolor = this.lineComparseColors[0]
        break
    }
    return result
  }
}
